import { render } from "./Diagnosis.vue?vue&type=template&id=51dd1354&scoped=true"
import script from "./Diagnosis.vue?vue&type=script&lang=js"
export * from "./Diagnosis.vue?vue&type=script&lang=js"

import "./Diagnosis.vue?vue&type=style&index=0&id=51dd1354&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dd1354"]])

export default __exports__